import { faqApi } from './faq.api';

export const faqActions = {
  async getFaqs({ commit }, payload) {
    try {
      commit('GET_FAQS_LOADING');
      const response = await faqApi.getFaqs(payload);
      commit('GET_FAQS_SUCCESS', response.data);
      return response;
    } catch (error) {
      commit('GET_FAQS_ERROR', error.response);
    }
  },
  async getFaq({ commit }, id) {
    try {
      commit('GET_FAQ_LOADING');
      const response = await faqApi.getFaq(id);
      commit('GET_FAQ_SUCCESS', response.data);
    } catch (error) {
      commit('GET_FAQ_ERROR', error.response);
    }
  },
  async addFaq({ commit }, body) {
    try {
      commit('ADD_FAQ_LOADING');
      const response = await faqApi.addFaq(body);
      commit('ADD_FAQ_SUCCESS', response.data);
    } catch (error) {
      commit('ADD_FAQ_ERROR', error.response);
    }
  },
  async deleteFaq({ commit }, id) {
    try {
      commit('DELETE_FAQ_LOADING');
      const response = await faqApi.deleteFaq(id);
      commit('DELETE_FAQ_SUCCESS', response.data);
    } catch (error) {
      commit('DELETE_FAQ_ERROR', error.response);
    }
  },
  async updateFaq({ commit }, { id, body }) {
    try {
      commit('UPDATE_FAQ_LOADING');
      const response = await faqApi.updateFaq(id, body);
      commit('UPDATE_FAQ_SUCCESS', response.data);
    } catch (error) {
      commit('UPDATE_FAQ_ERROR', error.response);
    }
  },
};
